import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.match";
import axios from "axios"; // import store from '@/store'

import { setToken, getToken, localRead } from "@/libs/util";

var qs = require("qs");

import { Message } from "view-design";

var _store;

function getStore() {
  if (!_store) {
    _store = require("@/store").default; // webpack / Vue CLI 等 CommonJS 环境可用
  }

  return _store;
} // 自定义判断元素类型JS


function toType(obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
} // 参数过滤函数


function filterNull(o) {
  for (var key in o) {
    if (o[key] === null || o[key] === "") {
      delete o[key];
    }

    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }

  return o;
} // 防止token过期重复弹窗


var _isLoggingOut = false;

var addErrorLog = function addErrorLog(errorInfo) {
  var statusText = errorInfo.statusText,
      status = errorInfo.status,
      responseURL = errorInfo.request.responseURL;
  var info = {
    type: "ajax",
    code: status,
    mes: statusText,
    url: responseURL
  };
  if (!responseURL.includes("save_error_logger")) getStore().dispatch("addErrorLog", info);
};

var HttpRequest =
/*#__PURE__*/
function () {
  function HttpRequest() {
    var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseURL;

    _classCallCheck(this, HttpRequest);

    this.baseUrl = baseUrl;
    this.queue = {};
  }

  _createClass(HttpRequest, [{
    key: "getInsideConfig",
    value: function getInsideConfig(contentType) {
      var ct = {
        "Content-Type": "application/json"
      };

      if (contentType == "FormData") {
        ct["Content-Type"] = "multipart/form-data;";
      } else if (contentType == "form") {
        ct["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
      }

      if (getToken()) {
        ct["Authorization"] = getToken();
      }

      var local = localRead("local");

      if (local === "zh-CN") {
        ct["Accept-Language"] = "zh";
      } else if (local === "en-US") {
        ct["Accept-Language"] = "en";
      }

      var config = {
        baseURL: this.baseUrl,
        headers: _objectSpread({}, ct),
        paramsSerializer: function paramsSerializer(params) {
          return qs.stringify(params, {
            arrayFormat: "repeat"
          });
        }
      };
      return config;
    }
  }, {
    key: "destroy",
    value: function destroy(url) {
      delete this.queue[url];

      if (!Object.keys(this.queue).length) {// Spin.hide()
      }
    }
  }, {
    key: "interceptors",
    value: function interceptors(instance, url) {
      var _this = this;

      // 请求拦截
      instance.interceptors.request.use(function (config) {
        //过滤参数
        if (config.data) {
          config.data = filterNull(config.data);
        } // 添加全局的loading...


        if (!Object.keys(_this.queue).length) {// Spin.show() // 不建议开启，因为界面不友好
        }

        _this.queue[url] = true;
        return config;
      }, function (error) {
        return Promise.reject(error);
      }); // 响应拦截

      instance.interceptors.response.use(function (res) {
        _this.destroy(url);

        var data = res.data,
            status = res.status; //登录过期，重新登录

        if (data.result === 107 || data.result === 812 || data.result === 813) {
          //删除 session状态，跳转登录页面（多个接口同时返回过期时只弹一次）
          if (!_isLoggingOut) {
            _isLoggingOut = true;
            setToken("");
            Message.error({
              duration: 3,
              content: "登录过期，请求重新登录",
              onClose: function onClose() {
                _isLoggingOut = false;
                location.reload();
              }
            });
          }
        }

        return _objectSpread({}, data);
      }, function (error) {
        _this.destroy(url);

        var errorInfo = error.response;

        if (!errorInfo) {
          var _JSON$parse = JSON.parse(JSON.stringify(error)),
              _JSON$parse$request = _JSON$parse.request,
              statusText = _JSON$parse$request.statusText,
              status = _JSON$parse$request.status,
              config = _JSON$parse.config;

          errorInfo = {
            statusText: statusText,
            status: status,
            request: {
              responseURL: config.url
            }
          };
        }

        addErrorLog(errorInfo);
        return Promise.reject(error);
      });
    }
  }, {
    key: "request",
    value: function request(options, contentType) {
      var instance = axios.create();
      options = Object.assign(this.getInsideConfig(contentType), options);
      this.interceptors(instance, options.url);
      return instance(options);
    }
  }]);

  return HttpRequest;
}();

export default HttpRequest;